<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage'
      :current='page' :count='count'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <!-- <div class="queryItem">
            <label>查询日期:</label>
   <timeStampDatePicker :maxlength='100' placeholder='请输入' class="item"
              clearable v-model.trim='query.usageStartTime'></timeStampDatePicker>

          </div> -->
          <div class="queryItem">
            <label>选择药品:</label>
           <goodsSelect :maxlength='100' placeholder='请输入' class="item" clearable ref='goodsSelect'
              v-model.trim='query.goodsName'></goodsSelect>
          </div>
  <div class="queryItem">
            <label>截止时间:</label>
            <timeStampDatePicker v-model="query.reportQueryEndTime" placeholder='请选择' class="item" clearable></timeStampDatePicker>
          </div>
           <div class="queryItem">
            <label>药店类型:</label>
            <lk-select v-model="query.storeTypeCode" placeholder='请选择' class="item" >
              <lk-option v-for="(item,i) in storeTypeList" :key="i" :value='i'>{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb16">
             <DownloadButton @on-click="download" v-if="handlePermission('patientRebuyReportExport')">
          </DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
// import supplier from '../../services/supplier';
import base from '../../services/base';
// import DtpDatePicker from '../../components/DtpDatePicker.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';
// import location from '../../components/location';
import goodsSelect from '../../components/tools/goodsSelect.vue';
// const { hospital } = base;
export default {
  name: 'PatientPurchaseAgainList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    // location,
    goodsSelect,
  },
  computed: {
    storeTypeList() {
      return this.$store.getters.getStoreTypeList;
    },
  },
  data() {
    return {

      // registerTypeList: {
      //   1: '处方创建',
      //   2: '邻客智慧药房公众号',
      //   3: '邻客健康管家',
      //   4: '用药咨询',
      // },

      columns: [
        {
          title: '患者ID',
          key: 'patientId',
          minWidth: 116,
        },
        {
          title: '姓名',
          key: 'patientName',
          minWidth: 116,
        },
        {
          title: '联系方式',
          key: 'patientPhone',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'statusStr',
          minWidth: 116,
        },

        {
          title: '应复购次数',
          key: 'shouldNumInt',
          minWidth: 116,
        },
        // {
        //   title: '已复购次数',
        //   key: 'alreadyNum',
        //   minWidth: 116,
        // },
        {
          title: '准时复购次数',
          key: 'onTimeNum',
          minWidth: 116,
        },
        {
          title: '延迟复购次数',
          key: 'delayNum',
          minWidth: 116,
        },
        {
          title: '提前复购次数',
          key: 'earlyNum',
          minWidth: 116,
        },

        {
          title: '当期内最近一次用药日期',
          key: 'lastUsageDate',
          minWidth: 116,
        },
        {
          title: '用药周期',
          key: 'usageCycle',
          minWidth: 116,
        },

        {
          title: '是否复购1',
          key: 'recall1',
          minWidth: 116,
        },
        {
          title: '未复购原因1',
          key: 'reason1',
          minWidth: 116,
        },
        {
          title: '是否复购2',
          key: 'recall2',
          minWidth: 116,
        },
        {
          title: '未复购原因2',
          key: 'reason2',
          minWidth: 116,
        },
        {
          title: '是否复购3',
          key: 'recall3',
          minWidth: 116,
        },
        {
          title: '未复购原因3',
          key: 'reason3',
          minWidth: 116,
        },
        {
          title: '创建门店',
          key: 'storeName',
          minWidth: 116,
        },
        {
          title: '性别',
          key: 'patientGender',
          minWidth: 116,
        },
        {
          title: '年龄',
          key: 'age',
          minWidth: 116,
        },
        {
          title: '处方医院',
          key: 'prescriptionHospital',
          minWidth: 116,
        },
        {
          title: '处方科室',
          key: 'hospitalDept',
          minWidth: 116,
        },
        {
          title: '疾病名称',
          key: 'diseaseName',
          minWidth: 116,
        },
        {
          title: '诊断补充',
          key: 'additionalRemark',
          minWidth: 116,
        },


      ],


      query: {
        duration: [], storeTypeCode: '1',
      },

      tableData: [],

    };
  },
  methods: {


    download() {
      const params = this.formatParams(this.params);
      params.page = 0;
      params.size = 0;
      delete params.encrypt;
      // params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      // delete params.duration;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      // params.type = 2;
      base.patient.downloadPatientRebuyList(params).then((res) => {
        // utils.downLoadExcel(res, '处方药销售记录查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    clear() {
      this.query = {
        storeTypeCode: '1',
        // goodsStoreIdList: [],
      };
      this.$refs.goodsSelect.clear();
    },
    formatParams(params) {
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      // if (temp.duration.length) {
      //   temp.createTimeStart = temp.duration[0];
      //   temp.createTimeEnd = temp.duration[1];
      // }
      return temp;
    },
    getData() {
      // this.params.page = this.page;
      // this.params.size = this.size;
      // console.log(this.query.goodsStoreId);

      if (!this.query.goodsName) {
        this.$Message.error('请选择商品');
        return;
      }


      this.params = this.formatParams(this.query);
      // this.params.encrypt = true;
      base.patient.getPatientRebuyList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = utils.deepClone(item);
            // result.proceedsAmount = item.proceedsAmount;
            console.log(item);

            result.patientGender = this.publicParams.genderList[result.patientGender];
            // result.createTime = utils.formatTime(result.createTime);
            result.lastUsageDate = utils.formatDate(result.lastUsageDate);
            // result.buyStoreNames = item.buyStoreNames;
            result.recall1 = this.$store.getters.getJudgeStr(item.recall1);
            result.recall2 = this.$store.getters.getJudgeStr(item.recall2);
            result.recall3 = this.$store.getters.getJudgeStr(item.recall3);
            result.reason1 = this.$store.getters.getNoRebuyReasonStr(result.reason1);
            result.reason2 = this.$store.getters.getNoRebuyReasonStr(result.reason2);
            result.reason3 = this.$store.getters.getNoRebuyReasonStr(result.reason3);
            // [result.recall1];
            // result.reason2 = [result.recall2];
            // result.reason3 = [result.recall3];

            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },


    // addNew() {
    //   this.$router.push({
    //     name: 'supplierGeneralAdd',
    //   });
    // },

  },
  mounted() {

    // this.$set(this.query, 'usageStartTime', new Date().getTime());

  },
};

</script>

<style lang="less" scoped>


</style>
